import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

import './pages/app/app-home';
import './ponents/header/app-header';

import { router } from './router';

@customElement('app-index')
export class AppIndex extends LitElement {
  constructor() {
    super();
  }

  firstUpdated() {
    router.addEventListener('route-changed', () => {
      if ("startViewTransition" in document) {
        return (document as any).startViewTransition(() => {
          this.requestUpdate();
        });
      }
      else {
        this.requestUpdate();
      }
    });
  }

  render() {
    return router.render();
  }
}
